// CQZ: conservative French polish. No URL overrides.
(function () {
  function isFrenchLocale() {
    var lang = (document.documentElement.getAttribute('lang') || '').toLowerCase();
    return lang.indexOf('fr') === 0 || lang === '';
  }
  function normalizeText(text) {
    return (text || '').replace(/\s+/g, ' ').trim();
  }
  function replaceFrenchMenuLabels() {
    if (!isFrenchLocale()) return;
    var map = { 'Home': 'Accueil', 'Beauty': 'Soins' };
    document.querySelectorAll('.hdt-navigation a, .hdt-menu-link-text, .hdt-menu-drawer a, .hdt-drawer-menu a, nav a').forEach(function (el) {
      var text = normalizeText(el.textContent);
      if (map[text]) el.textContent = map[text];
    });
  }
  function hideEmptyMegaMenus() {
    document.querySelectorAll('.hdt-sub-menu.hdt-mega-menu').forEach(function (menu) {
      var text = normalizeText(menu.textContent);
      if (!text || text.indexOf('Veuillez ajouter du contenu') !== -1 || text.indexOf('Please add content') !== -1) {
        menu.style.display = 'none';
        menu.setAttribute('aria-hidden', 'true');
      }
    });
  }
  function run() { replaceFrenchMenuLabels(); hideEmptyMegaMenus(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();
  var observer = new MutationObserver(run);
  observer.observe(document.documentElement, { childList: true, subtree: true });
})();
